import {
  Divider,
  Sheet,
  Stack,
  Tab,
  tabClasses,
  TabList,
  TabPanel,
  Tabs,
  Typography,
} from "@mui/joy";
import { theme } from "../../../../../components/Theme";
import { Box } from "@mui/material";
import Gauth from "../../../../../components/Gauth";
import { useTranslation } from "react-i18next";
import LoadingModal from "../../../../../components/LoadingModal/LoadingModal";
import useContainer from "./useContainer";
import BusinessSelectionModal from "./BusinessSelectionModal/BusinessSelectionModal";
import PhoneSigninForm from "./PhoneSignin/PhoneSigninForm";
import EmailSigninForm from "./EmailSignin/EmailSigninForm";

const SigninForm = ({ handleGoToNext }: { handleGoToNext: () => void }) => {
  const { t } = useTranslation();
  const {
    googleSignInHandler,
    isLoading,
    openBusinessSelectionModal,
    closeBusinessModalHandler,
  } = useContainer();
  return (
    <Sheet
      sx={{
        flex: 1,
        p: "16px",
        border: `1px solid ${theme.palette.neutral[300]}`,
        borderRadius: "8px",
      }}
    >
      {/* signin form */}
      <Stack
        component="section"
        data-testid="login"
        id="login"
        sx={{
          flex: 1,
          pb: "16px",
          px: "16px",
          gap: "16px",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Typography
          display={"flex"}
          alignItems={"center"}
          level="text-md-semibold"
          textColor={theme.palette.others.icon_outline}
        >
          Log in for faster checkout
        </Typography>

        <Tabs aria-label="signup-method" defaultValue={0}>
          <TabList
            sx={{
              [`&& .${tabClasses.root}`]: {
                "&:hover": {
                  bgcolor: "transparent",
                },
                [`&.${tabClasses.selected}`]: {
                  "&::after": {
                    bgcolor: "primary.500",
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    height: 2,
                  },
                  color: "primary.plainColor",
                },
                bgcolor: "transparent",
                flex: "initial",
                paddingY: 2,
              },
              justifyContent: "space-evenly",
              paddingTop: 1,
            }}
          >
            <Tab
              sx={{
                width: "50%",
                "&.Mui-selected": {
                  fontWeight: 700,
                  "& .tab-text": {
                    color: "primary.500",
                  },
                },
              }}
            >
              <Typography
                fontSize={16}
                className="tab-text"
                sx={{ fontWeight: "400px" }}
              >
                {t("landing.signup.methods.email")}
              </Typography>
            </Tab>
            <Tab
              sx={{
                width: "50%",
                "&.Mui-selected": {
                  fontWeight: 700,
                  "& .tab-text": {
                    color: "primary.500",
                  },
                },
              }}
            >
              <Typography
                fontSize={16}
                className="tab-text"
                sx={{ fontWeight: "400px" }}
              >
                {t("landing.signup.methods.phone")}
              </Typography>
            </Tab>
          </TabList>

          <Box
            component="section"
            data-testid="register"
            id="register"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              py: "1rem",
            }}
          >
            <TabPanel value={0} sx={{ p: 0 }}>
              <EmailSigninForm handleGoToNext={handleGoToNext} />
              <Divider sx={{ my: 2 }}> {t("landing.or")}</Divider>
              <Box
                onClick={googleSignInHandler}
                width={"300px"}
                marginX={"auto"}
              >
                <Gauth />
              </Box>
            </TabPanel>
            <TabPanel value={1} sx={{ p: 0 }}>
              <PhoneSigninForm handleGoToNext={handleGoToNext} />
            </TabPanel>
          </Box>
        </Tabs>
      </Stack>

      {/* modal */}
      <LoadingModal isLoading={isLoading} />
      <BusinessSelectionModal
        close={closeBusinessModalHandler}
        isOpen={openBusinessSelectionModal}
      />
    </Sheet>
  );
};

export default SigninForm;
